import { createSelector } from 'reselect';

import getDisplaySecondaryNav from '@/state/selectors/secondary-nav/get-display-secondary-nav';
import getSecondaryNavParentList from '@/state/selectors/secondary-nav/get-secondary-nav-parent-list';

const getCanShowSecondaryNav = createSelector(
	[getDisplaySecondaryNav, getSecondaryNavParentList],
	(displaySecNav, secondaryNavParentList) =>
		displaySecNav &&
		secondaryNavParentList &&
		secondaryNavParentList.length > 0,
);

export default getCanShowSecondaryNav;
